import React from 'react';
import { FaqItem } from '../FaqItem';
import styles from './FaqSection.css';

const FAQS = [
    {
        question: 'Is Boundly digital or printed?',
        answer: 'Boundly is fully digital. Your edited chapters and selected photos come together in a Digital Family Legacy Book you can access online. No printed copy is included.'
    },
    {
        question: 'Can I use it for myself or give it to someone?',
        answer: 'Both. Record your own story or give Boundly to a parent, grandparent, or another family member so they can preserve theirs.'
    },
    {
        question: 'What if I am not a good writer?',
        answer: 'You do not need writing experience. Speak or type naturally, and Boundly turns unstructured answers into clear, edited chapters.'
    },
    {
        question: 'Is it easy enough for an older parent?',
        answer: 'Yes. There is no blank page and no writing experience required. They can simply speak, answer one question at a time, pause, and return whenever they are ready.'
    },
    {
        question: 'Are my stories private, and what happens if I cancel?',
        answer: 'Your stories remain private unless you choose to share them. Boundly does not sell or share your stories. If you cancel, you keep access to your saved chapters.'
    }
];

function FaqSection() {
    return (
        <section id='faq' className={styles.root}>
            <div className={styles.container}>
                <div className={styles.heading}>
                    <h2 className={styles.title}>Everything you need to know before you begin.</h2>
                    <p className={styles.subtitle}>For you today. For your family for generations to come.</p>
                </div>
                <ul className={styles.list}>
                    {FAQS.map((faq, index) => (
                        <FaqItem
                            key={faq.question}
                            question={faq.question}
                            answer={faq.answer}
                            isOpenByDefault={index === 0}
                        />
                    ))}
                </ul>
            </div>
        </section>
    );
}

export {
    FaqSection
};
